var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap c-width",class:{ isDocTitle: _vm.isDocTitle }},[_vm._l((_vm.titleArr),function(item,index){return _c('div',{key:index,staticClass:"title"},[_vm._v(" "+_vm._s(item)+" ")])}),_c('div',{staticClass:"line"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }